<template>
  <div>
    <div
      class="top-bar d-flex align-items-center justify-content-between w-100 bg-white border-color-light-gray pr-1"
    >
      <location-selector />
      <ScheduledMaintenanceView
        v-show="
          typeof scheduledMaintenance !== 'undefined' &&
            JSON.parse(scheduledMaintenance).show
        "
        :data="scheduledMaintenance"
      ></ScheduledMaintenanceView>
      <trial-countdown
        v-show="
          typeof scheduledMaintenance !== 'undefined' &&
            !JSON.parse(scheduledMaintenance).show
        "
      />
      <div class="d-flex align-items-center">
        <div
          v-if="hasCurrentUserPermission('messages')"
          class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center position-relative"
          @click="openMessagesModal"
          id="tooltip-messages"
        >
          <i
            style="padding: 0.5em 0.6em; font-size: 14px;"
            class="top-bar-icon fas fa-comment-dots"
          ></i>
          <span v-show="hasMessages" class="action-badge"></span>
          <b-tooltip target="tooltip-messages" variant="secondary">
            Messages
          </b-tooltip>
        </div>
        <div v-if="hasCurrentUserPermission('reports')">
          <div
            class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center"
            @click="openReportRequestsModal"
            id="tooltip-report-requests"
          >
            <i
              style="padding: 0.5em 0.6em; font-size: 14px;"
              class="top-bar-icon fas fa-book"
            ></i>
          </div>
          <b-tooltip target="tooltip-report-requests" variant="secondary"
            >Report Requests</b-tooltip
          >
        </div>
        <div
          class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center position-relative"
          @click="toggleNotifications"
          id="tooltip-notifications"
        >
          <i
            style="padding: 0.5em 0.6em; font-size: 14px;"
            class="top-bar-icon fas fa-bell"
          ></i>
          <span v-show="hasNotifications" class="action-badge"></span>
          <b-tooltip target="tooltip-notifications" variant="secondary">
            Notifications
          </b-tooltip>
        </div>
        <div v-if="hasCurrentUserPermission('auditLogs')">
          <div
            class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center"
            @click="openAuditModal"
            id="tooltip-logs"
          >
            <i
              style="padding: 0.5em 0.7em; font-size: 14px;"
              class="top-bar-icon fas fa-clipboard-list"
            ></i>
          </div>
          <b-tooltip target="tooltip-logs" variant="secondary">Logs</b-tooltip>
        </div>
        <div v-if="hasCurrentUserPermission('settings')">
          <div
            class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center"
            @click="openSettingsModal"
            id="tooltip-settings"
          >
            <i
              style="padding: 0.5em 0.6em; font-size: 14px;"
              class="top-bar-icon fas fa-cog"
            ></i>
          </div>
          <b-tooltip target="tooltip-settings" variant="secondary">
            Settings
          </b-tooltip>
        </div>
        <div
          class="action-icon-container border-color-extra-light-gray color-custom-dark-grey hover-pointer d-flex align-items-center"
          @click="showHideChat"
          id="tooltip-help"
        >
          <i
            style="padding: 0.5em 0.7em; font-size: 14px;"
            class="top-bar-icon fas fa-question"
          ></i>
        </div>
        <b-tooltip target="tooltip-help" variant="secondary">Help</b-tooltip>

        <b-dropdown
          toggle-class="text-decoration-none hover-pointer"
          no-caret
          variant="link"
        >
          <template v-slot:button-content>
            <div class="d-flex align-items-center user-container">
              <div
                class="bg-med-light-gray rounded-circle position-relative picture-preview"
                style="width: 40px; height: 40px;"
              >
                <img
                  :src="
                    currentUser && currentUser.avatar
                      ? currentUser.avatar
                      : require('../../assets/avatar-example.png')
                  "
                />
                <img
                  height="12"
                  width="12"
                  class="ml-2 user-active"
                  :src="require('../../assets/icons/user-active.png')"
                />
              </div>
              <div class="d-flex align-items-center profile-user-name">
                <div>
                  <div
                    class="color-custom-dark-grey"
                    style="font-size:14px;margin-left:10px;margin-right:10px;"
                  >
                    {{ userFormatted }}
                  </div>
                  <div
                    class="color-custom-grey"
                    style="font-size:12px;margin-left:10px;margin-right:10px;"
                  >
                    {{ currentUser ? currentUser.role.name : "" }}
                  </div>
                </div>
                <i class="fas fa-chevron-down color-custom-dark-grey"></i>
              </div>
            </div>
          </template>
          <b-dropdown-item @click="logout">
            Logout
          </b-dropdown-item>
          <b-dropdown-item @click="showMyAccountModal = true">
            My Account
          </b-dropdown-item>
          <b-dropdown-item @click="showPasswordModal = true">
            Change Password
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div
      v-if="showNotifications"
      ref="notifications-container"
      class="position-fixed"
      style="width: 350px; z-index: 10;"
    >
      <user-notifications v-model="showNotifications" />
    </div>
    <my-account-modal
      v-if="showMyAccountModal"
      :dismissable="true"
      v-model="showMyAccountModal"
    />
    <change-password-modal
      v-if="showPasswordModal"
      v-model="showPasswordModal"
    />
    <audit-modal v-if="showAuditModal" v-model="showAuditModal" />
    <b-modal
      centered
      scrollable
      static
      hide-footer
      title="Settings"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="gray"
      header-class="bg-white align-items-center"
      content-class="h-100"
      modal-class="settings-modal modal-fullscreen"
      v-model="showSettingsModal"
      body-class="bg-extra-light-gray p-0"
    >
      <setting-tabs :showing="showSettingsModal" />
    </b-modal>
    <b-modal
      centered
      scrollable
      static
      hide-footer
      title="Reports"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="gray"
      header-class="bg-white align-items-center"
      content-class="h-100"
      modal-class="reports-modal modal-fullscreen"
      v-model="showReportsModal"
      body-class="bg-extra-light-gray p-0"
    >
      <report-tabs :showing="showReportsModal" />
    </b-modal>
    <b-modal
      centered
      scrollable
      static
      no-enforce-focus
      hide-footer
      title="Messages"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="gray"
      header-class="bg-white align-items-center"
      content-class="h-100"
      modal-class="reports-modal modal-fullscreen"
      v-model="showMessagesModal"
      body-class="bg-extra-light-gray p-0"
    >
      <template v-slot:modal-header>
        <h4 class="modal-title">
          <b>Messages</b>
        </h4>
        <div class="d-flex">
          <b-button
            class="smaller-button button-custom-blue"
            variant="primary"
            size="sm"
            @click="showModal = true"
          >
            Send mass message</b-button
          >
          <b-button-close @click="showMessagesModal = false"></b-button-close>
        </div>
      </template>
      <chat :showing="showMessagesModal" />
    </b-modal>
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
    />
    <chat-mass-message-modal
      v-if="showModal"
      v-model="showModal"
      @onModify="onModify"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import notificationServer from "../../server/notification";
import chatsServer from "../../server/chat";
import { setToken } from "../../helpers/session";
import MyAccountModal from "./MyAccountModal.vue";
import ChangePasswordModal from "./ChangePasswordModal.vue";
import LocationSelector from "./LocationSelector.vue";
import AuditModal from "./AuditModal";
import SettingTabs from "../setting/SettingTabs.vue";
import ReportTabs from "../report/ReportTabs.vue";
import TrialCountdown from "./TrialCountdown.vue";
import UserNotifications from "./UserNotifications.vue";
import Chat from "../chat/ChatIndex.vue";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";
import chatSignalRConnection from "../../signalr/chat";
import ChatMassMessageModal from "../chat/ChatMassMessageModal.vue";
import ScheduledMaintenanceView from "./ScheduledMaintenanceView.vue";

export default {
  name: "Topbar",
  components: {
    ScheduledMaintenanceView,
    MyAccountModal,
    ChangePasswordModal,
    LocationSelector,
    AuditModal,
    ReportTabs,
    SettingTabs,
    TrialCountdown,
    UserNotifications,
    Chat,
    ReportRequestIndex,
    ChatMassMessageModal
  },
  data() {
    return {
      showMyAccountModal: false,
      showPasswordModal: false,
      showAuditModal: false,
      chatSubscribed: false,
      showSettingsModal: false,
      showReportsModal: false,
      showMessagesModal: false,
      showReportRequestsModal: false,
      showNotifications: false,
      notificationsInterval: null,
      hasNotifications: false,
      hasMessages: false,
      showModal: false
    };
  },
  async created() {
    await this.fetchCurrentUser();
    await this.checkIfHasMessages();
    window.addEventListener("resize", this.positionNotificationsPanel);
    this.notificationsInterval = setInterval(async () => {
      if (!this.showNotifications) {
        this.hasNotifications = await notificationServer.hasNewNotifications();
      }
    }, 30000);
    this.checkTopazPad();
    this.loadChat();
    this.hasNotifications = await notificationServer.hasNewNotifications();
    chatSignalRConnection.initialize("chat", this.signalRAppUrl);
    chatSignalRConnection.on("NewMainAppChatMessage", async result => {
      if (
        result.tenantName === this.currentTenant &&
        result.receivers.includes(this.currentUser.id)
      ) {
        await this.checkIfHasMessages();
      }
    });
    chatSignalRConnection.start(() => {});
  },
  destroyed() {
    window.removeEventListener("resize", this.positionNotificationsPanel);
    clearInterval(this.hasNotifications);
    chatSignalRConnection.stop();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "fetchCurrentUser"]),
    ...mapMutations("layout", ["setTopazInstalled"]),
    logout() {
      setToken("");
      location.reload();
    },
    async checkIfHasMessages() {
      this.hasMessages = await chatsServer.hasUnSeenMessages(
        this.currentUser.id
      );
      if (this.hasMessages) this.notifyMe();
      if (this.showMessagesModal) this.hasMessages = false;
    },
    loadChat() {
      window.hsConversationsSettings = {
        loadImmediately: true,
        inlineEmbedSelector: "#hubspot-chat"
      };
      let chatScript = document.createElement("script");
      chatScript.setAttribute("id", "hs-script-loader");
      chatScript.setAttribute("src", "//js-na1.hs-scripts.com/7358632.js");
      document.body.appendChild(chatScript);
    },
    showHideChat() {
      document.getElementById("hubspot-chat-holder").style.visibility =
        document.getElementById("hubspot-chat-holder").style.visibility ==
        "hidden"
          ? "visible"
          : "hidden";
    },
    checkTopazPad() {
      let isTopazIntalled = false;
      try {
        isTopazIntalled = window.IsSigWebInstalled();
      } catch (e) {
        isTopazIntalled = false;
        // If exception throws, means the current machine doesn't have the SignaturePad driver.
      }
      this.setTopazInstalled(isTopazIntalled);
    },
    openSettingsModal() {
      window.dispatchEvent(new Event("resize"));
      this.showSettingsModal = true;
    },
    openMessagesModal() {
      window.dispatchEvent(new Event("resize"));
      this.showMessagesModal = true;
    },
    openReportRequestsModal() {
      window.dispatchEvent(new Event("resize"));
      this.showReportRequestsModal = true;
    },
    openAuditModal() {
      this.showAuditModal = true;
    },
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      this.$nextTick(() => {
        if (this.showNotifications) {
          const el = this.$refs["notifications-container"];
          const rect = this.$el
            .querySelector("#tooltip-notifications")
            .getBoundingClientRect();
          el.style.top = rect.top + 45 + "px";
          el.style.left =
            window.innerWidth > rect.left + 350 + 10
              ? rect.left + 10 + "px"
              : window.innerWidth - 350 + "px";
        }
      });

      if (this.showNotifications) {
        this.hasNotifications = false;
      }
    },
    notifyMe() {
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      } else if (Notification.permission === "granted") {
        new Notification("You have unseen messages on the Chat!");
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            new Notification("You have unseen messages on the Chat!");
          }
        });
      }
    },
    onModify() {
      this.showModal = false;
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      currentTenant: state => state.systemSetting.currentTenant,
      signalRAppUrl: state => state.systemSetting.signalRAppUrl,
      scheduledMaintenance: state => state.systemSetting?.scheduledMaintenance
    }),
    ...mapGetters("layout", ["hasCurrentUserPermission"]),
    userFormatted() {
      return this.currentUser ? this.formatUser(this.currentUser) : "";
    }
  },
  watch: {
    showMessagesModal: async function(newValue) {
      if (!newValue) {
        this.hasMessages = await chatsServer.hasUnSeenMessages(
          this.currentUser.id
        );
      }
    },
    hasNotifications: {
      handler: function(value) {
        if (value) {
          this.$root.$emit("fetchNotifications");
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.top-bar {
  height: 65px;
  z-index: 10;
}

.top-bar >>> .top-bar-icon,
.top-bar >>> .profile-user-name {
  background-color: #fff !important;
  transition: background-color 300ms ease;
  box-shadow: 0px 0px 2px #888;
}

.top-bar >>> .top-bar-icon:hover,
.top-bar >>> .user-container:hover .profile-user-name {
  background-color: #e9edf3 !important;
}

.top-bar >>> .locations-menu {
  padding: 0px !important;
}

.top-bar-icon {
  display: inline-block;
  border-radius: 60px;
  box-shadow: 0px 0px 2px #888;
  font-size: 16px;
  color: #888;
}

.action-icon-container {
  padding: 7px 11px;
  border-right: 2px solid;
  font-size: 22px;
}

.action-icon-container .action-badge {
  display: block;
  position: absolute;
  top: 4px;
  right: 8px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #ff6161;
}

.user-container {
  margin-right: 13px;
}

.user-active {
  position: absolute;
  bottom: 0;
  right: 0;
}

.profile-user-name {
  margin-left: -10px;
  line-height: 14px;
  text-align: left;
  padding: 3px 10px 3px 3px;
  border-radius: 0 50px 50px 0;
}
</style>
